
export function Disclaimer() {

  return (

    <div className="bg-grey-mercury p-8 sm:py-14">
      
      <div className="mx-auto max-w-5xl">

        <p className="italic leading-5 text-center text-sm sm:text-base">
        
          The score provided is derived from an internal assessment methodology based solely on the responses 
          
          submitted in this survey. It is intended for informational purposes only and reflects a subjective 
          
          interpretation of your inputs. The results do not constitute a comprehensive laboratory analysis or 
          
          professional advice and may not fully represent your actual level of optimization. For a complete 
          
          evaluation and personalized recommendations, please consult one of our specialists.
          
        </p>

      </div>

    </div>

  )

}
